import './Header.scss';

import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/UserPanel';
import { ThemeSwitcher } from '../theme-switcher/ThemeSwitcher';
import type { HeaderProps } from '../../types';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export default function Header({ menuToggleEnabled, title, toggleMenu, className }: HeaderProps) {
    const navigate = useNavigate();

    const navigateToProfile = useCallback(() => {
        navigate("/home");
    }, [navigate]);

    return (
        <header className={`header-component ${className} header-application`}>
            <Toolbar className={'header-toolbar'}>
                <Item
                    visible={menuToggleEnabled}
                    location={'before'}
                    widget={'dxButton'}
                    cssClass={'menu-button'}
                >
                    <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
                </Item>
                <Item
                    location={'before'}
                    visible={!!title}
                >
                    <label style={{ cursor: "pointer", fontSize: "20px", fontWeight: "500" }} onClick={navigateToProfile}>{title}</label>
                </Item>
                <Item
                    location={'after'}
                >
                    <ThemeSwitcher />
                </Item>
                <Item location='after' locateInMenu='auto'>
                    <UserPanel />
                </Item>
            </Toolbar>
        </header>
    )
}
